import type { ChatTurn } from './useAiChat';

const KEY = 'preformiq_coach_chat';
const MAX_TURNS = 8;

function storageKey(userId?: string) {
  return userId ? `${KEY}:${userId}` : KEY;
}

export function loadCoachChatHistory(userId?: string): ChatTurn[] {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as ChatTurn[];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (t) => (t.role === 'user' || t.role === 'assistant') && String(t.content ?? '').trim(),
    );
  } catch {
    return [];
  }
}

export function saveCoachChatHistory(userId: string | undefined, turns: ChatTurn[]) {
  if (!turns.length) return;
  const trimmed = turns.slice(-MAX_TURNS);
  localStorage.setItem(storageKey(userId), JSON.stringify(trimmed));
}

export function clearCoachChatHistory(userId?: string) {
  localStorage.removeItem(storageKey(userId));
}
